import React, { Fragment, memo } from 'react';
//Componentes
import Botones from '../../../components/UI/botonera/headerBotones.js';
import CajaTexto from '../../../components/UI/cajaTexto/cajaTexto.jsx';
import ComboBox from '../../../components/UI/comboBox/combobox.jsx';
import CheckBox from '../../../components/UI/checkBox/checkBox.jsx';
function mantParametrosInt(props) {
    return (
        <Fragment>
            <div className="col-md-12">
                <div className='row'>
                    <div className="col-md-6">
                        <h1>{props.Titulo}</h1>
                    </div>
                    <div className="col-md-6 text-right">
                        <div className="acciones">
                            <Botones
                                botones={props.botones}
                            />
                        </div>
                    </div>
                </div>
                <div className="content">
                    <div className="content-box box-primary">
                        <div className='row'>
                            <div className='row'>
                                <ComboBox id="cmbEstado" col="6" attributes={props.Datos.Estado.attributes} value={props.selectedEstado} label={props.Datos.Estado.attributes.label} datos={props.listaEstado} onChange={props.onhandleSelectedEstado} />
                                <CajaTexto col="6" id="CedulaJuridica" type="text" label={props.Datos.CedulaJuridica.attributes.label} value={props.Datos.CedulaJuridica.value} attributes={props.Datos.CedulaJuridica.attributes} onChangeInput={props.onChangeInput} />
                            </div>
                            <div className='row'>
                                <CajaTexto col="6" id="Rep_BalanceSit" type="text" label={props.Datos.Rep_BalanceSit.attributes.label} value={props.Datos.Rep_BalanceSit.value} attributes={props.Datos.Rep_BalanceSit.attributes} onChangeInput={props.onChangeInput} />
                                <CajaTexto col="6" id="Rep_EstadoResult" type="text" label={props.Datos.Rep_EstadoResult.attributes.label} value={props.Datos.Rep_EstadoResult.value} attributes={props.Datos.Rep_EstadoResult.attributes} onChangeInput={props.onChangeInput} />                                
                            </div>
                            <div className='row'>
                                <CajaTexto col="6" id="Rep_DiarioGral" type="text" label={props.Datos.Rep_DiarioGral.attributes.label} value={props.Datos.Rep_DiarioGral.value} attributes={props.Datos.Rep_DiarioGral.attributes} onChangeInput={props.onChangeInput} />
                                <CajaTexto col="6" id="Rep_AsientoDiario" type="text" label={props.Datos.Rep_AsientoDiario.attributes.label} value={props.Datos.Rep_AsientoDiario.value} attributes={props.Datos.Rep_AsientoDiario.attributes} onChangeInput={props.onChangeInput} />                                
                            </div>
                            <div className='row'>                                
                                <CajaTexto col="6" id="Rep_AsientoDiarioConsolidado" type="text" label={props.Datos.Rep_AsientoDiarioConsolidado.attributes.label} value={props.Datos.Rep_AsientoDiarioConsolidado.value} attributes={props.Datos.Rep_AsientoDiarioConsolidado.attributes} onChangeInput={props.onChangeInput} />                                
                                <CheckBox id='PermiteCrecer' col="12" attributes={props.Datos.PermiteCrecer.attributes} value={props.Datos.PermiteCrecer.value} label={props.Datos.PermiteCrecer.attributes.label} onChange={props.handleCheckBox} />
                            </div>                            
                        </div>
                    </div>
                </div>
            </div>

        </Fragment>
    );
};
export default memo(mantParametrosInt);